import { render, staticRenderFns } from "./AttendanceRecordsPersonCard.vue?vue&type=template&id=91a05f8c"
import script from "./AttendanceRecordsPersonCard.vue?vue&type=script&lang=js"
export * from "./AttendanceRecordsPersonCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports